
























import { Vue } from "vue-property-decorator";
import AppPassword from "@/components/app-password.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  data() {
    return {
      errorStatus : 0
    };
  },
  components: { AppPassword },

  computed: {
    ...mapGetters("moncompte", ["getCurrentUser", "getErrorStatus"]),
  },
  methods: {
    checkSecret(code: number) {
      code === this.getCurrentUser.codepin ?
      this.errorStatus = 0:
      this.errorStatus = 1;
      this.$emit("checkSecret", code === this.getCurrentUser.codepin);
    },
    alertMsg() {
      let msgs = [
        "",
        "Code pin incorrect, veuillez reessayer",
      ];
      return msgs[this.errorStatus];
    },
  },
});
